import { WhiteTooltip } from '@AMIEWEB/Common';
import { GridCellParams } from '@mui/x-data-grid';
import { Theme } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectEditPreferencePetsRows } from 'store/redux-store/placement-mods/selectors';
import { makeStyles } from 'tss-react/mui';
import { getDisplayValue, inValidString } from '../utils';

const StyledTootltip = makeStyles()((theme: Theme) => ({
  arrow: {
    '&:before': {
      border: '1px solid #E3DFDF',
    },
    color: theme.palette.components.tooltip.arrowColor,
  },
  truncation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltipContent: {
    backgroundColor: theme.palette.components.tooltip.backgroundColor,
    border: '1px solid #E3DFDF',
    color: theme.palette.system.errorRed,
    fontWeight: 'normal',
  },
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomTooltipCellRenderer = React.memo(function CustomTooltipCellRenderer(cellParams: any) {
  const { classes } = StyledTootltip();
  const editPreferencePetsRequests = useSelector(selectEditPreferencePetsRows);
  const rowData = getDisplayValue(cellParams.row.id, editPreferencePetsRequests);

  const getTitle = row => {
    return inValidString(row?.type) ? 'Required' : '';
  };

  return (
    <WhiteTooltip
      arrow={true}
      title={getTitle(rowData)}
      classes={{ tooltip: classes.tooltipContent, arrow: classes.arrow }}
    >
      <span style={!rowData?.type ? { paddingLeft: '40px' } : null} className={classes.truncation}>
        {rowData?.type ? rowData?.type : '--'}
      </span>
    </WhiteTooltip>
  );
});

export const ErrorToolTipType = (params: GridCellParams) => {
  return <CustomTooltipCellRenderer {...params} />;
};
